(function () {
  const STORAGE_KEY = 'mr_cart_upsell_interaction';

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function saveCartAttribute(data) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          mr_cart_upsell_interacted: 'true',
          mr_cart_upsell_last_block: data.blockName || '',
          mr_cart_upsell_last_product_id: data.productId || '',
          mr_cart_upsell_last_product_title: data.productTitle || '',
          mr_cart_upsell_last_product_price: data.productPrice || '',
          mr_cart_upsell_last_click_at: new Date().toISOString()
        }
      })
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(
      '.mr-cart-upsell-card__quick-add-wrap button, .mr-cart-upsell-card__quick-add-wrap a'
    );

    if (!trigger) return;

    const card = trigger.closest('[data-mr-upsell-card]');
    if (!card) return;

    const block = card.closest('[data-mr-upsell-block]');

    const data = {
      blockName: card.dataset.mrUpsellBlock || block?.dataset.mrUpsellBlock || '',
      productId: card.dataset.productId || '',
      productTitle: card.dataset.productTitle || '',
      productPrice: card.dataset.productPrice || '',
      cartValueBefore: block?.dataset.mrCartValue || '',
      cartItemsCount: block?.dataset.mrCartItems || '',
      priority: block?.dataset.mrPriority || ''
    };

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...data,
        clickedAt: new Date().toISOString()
      })
    );

    pushDataLayer({
      event: 'cart_upsell_clicked',
      block_name: data.blockName,
      product_id: data.productId,
      product_name: data.productTitle,
      product_price: data.productPrice,
      cart_value_before: data.cartValueBefore,
      cart_items_count: data.cartItemsCount,
      cart_priority: data.priority
    });

    saveCartAttribute(data);
  });

  document.addEventListener('click', function (event) {
    const checkoutButton = event.target.closest('.cart__checkout-button');
    if (!checkoutButton) return;

    let interaction = null;

    try {
      interaction = JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (error) {}

    pushDataLayer({
      event: 'cart_checkout_clicked',
      cart_upsell_interacted: interaction ? true : false,
      last_upsell_block: interaction?.blockName || '',
      last_upsell_product_id: interaction?.productId || '',
      last_upsell_product_name: interaction?.productTitle || '',
      last_upsell_clicked_at: interaction?.clickedAt || ''
    });
  });
})();